var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-nav-page"},[_c('category-navigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }